// Rol "prospect": een potentieel energielabel dat het platform leert kennen op
// de (geanonimiseerde) Power2You-data. De server (utils/demo.js) vervangt in
// élke respons "Power2You" door de naam van het potentiële label; hier staat
// wat het scherm zelf nog moet weten:
//   - de labelnaam, voor teksten (documentatie, hideEtBrand) en de weergave;
//   - de afkorting waarmee klantnummers en factuurnummers getoond worden
//     (P2Y/2024/11/63 → ZON/2024/11/63; zie demoWeergave.js);
//   - de terugvertaling naar het bronlabel voor de labelspecifieke rekenregels
//     van Revenue (BRP-kost, onbalanstarieven, fee-uitzonderingen), die op de
//     échte labelnaam testen. Zonder die brug zou een prospect andere cijfers
//     zien dan een Power2You-master.
// Module-niveau: één prospect per sessie, gezet zodra de gebruiker bekend is.

export const PROSPECT_BRON_LABEL = 'Power2You';
// Twee rollen: potentieel energielabel en potentiële wederverkoper.
export const PROSPECT_ROLLEN = ['prospect_label', 'prospect_reseller'];
export const isProspectRol = (role) => PROSPECT_ROLLEN.includes(role);

let huidig = null;   // { naam, afkorting } of null

// Drie hoofdletters uit de naam: eerste letters van de woorden, aangevuld met
// medeklinkers ("Zonnestroom Energie" → ZE → ZEN? nee: ZON…). Regel: begint met
// de eerste letter van elk woord (max 3); korter dan 3 → aanvullen met de
// volgende letters van het eerste woord.
export function afkortingVoor(naam) {
  const woorden = String(naam || '').toUpperCase().replace(/[^A-Z0-9 ]/g, ' ').split(/\s+/).filter(Boolean);
  if (!woorden.length) return 'PRO';
  let afk = woorden.map((w) => w[0]).join('').slice(0, 3);
  for (let i = 1; afk.length < 3 && i < woorden[0].length; i += 1) afk += woorden[0][i];
  return (afk + 'XXX').slice(0, 3);
}

export function zetProspect(naam) {
  const n = String(naam || '').trim();
  huidig = n ? { naam: n, afkorting: afkortingVoor(n) } : null;
}
export const prospectActief = () => !!huidig;
export const prospectLabel = () => (huidig ? huidig.naam : '');
export const prospectAfkorting = () => (huidig ? huidig.afkorting : '');

// Het label zoals de rekenregels het kennen (prospectnaam → bronlabel).
export const bronLabel = (label) => (huidig && String(label || '').trim() === huidig.naam ? PROSPECT_BRON_LABEL : label);
// Het label zoals het scherm het toont (bronlabel → prospectnaam).
export const weergaveLabel = (label) => (huidig && String(label || '').trim() === PROSPECT_BRON_LABEL ? huidig.naam : label);

// Vrije tekst (documentatie, uitleg): elke vermelding van het bronlabel wordt de
// prospectnaam. Zonder prospect blijft de tekst zoals hij is.
export function verbergBronLabel(tekst) {
  if (!huidig || typeof tekst !== 'string') return tekst;
  return tekst.replace(/power\s*2\s*you/gi, huidig.naam);
}
